import "./styles/globals.css";
import BioPMWebsite from "./BioPMWebsite";
import AIReadinessPage from "./AIReadinessPage";

function App() {
  const path = window.location.pathname;

  if (path === "/ai-readiness") {
    return <AIReadinessPage />;
  }

  return <BioPMWebsite />;
}

export default App;
